import React, { useState } from 'react';
import './App.css';
import DataStructures from './components/DataStructures';
import Threading from './components/Threading';
import Http from './components/Http';
import SystemDesign from './components/SystemDesign';
import Calculus from './components/Calculus';
import LinearAlgebra from './components/LinearAlgebra';

function App() {
  const [topic, setTopic] = useState('datastructures');

  const renderTopic = () => {
    switch (topic) {
      case 'threading':
        return <Threading />;
      case 'http':
        return <Http />;
      case 'systemdesign':
        return <SystemDesign />;
      case 'calculus':
        return <Calculus />;
      case 'linearalgebra':
        return <LinearAlgebra />;
      case 'datastructures':
      default:
        return <DataStructures />;
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Senior Engineer Interview Prep</h1>
      </header>
      <nav className="App-nav">
        <button onClick={() => setTopic('datastructures')}>Data Structures</button>
        <button onClick={() => setTopic('threading')}>Threading</button>
        <button onClick={() => setTopic('http')}>HTTP</button>
        <button onClick={() => setTopic('systemdesign')}>System Design</button>
        <button onClick={() => setTopic('calculus')}>Calculus</button>
        <button onClick={() => setTopic('linearalgebra')}>Linear Algebra</button>
      </nav>
      <main>
        {renderTopic()}
      </main>
    </div>
  );
}

export default App;